import React from 'react'

// import classes from './EmpProfileImage.scss'

import ImageInput from '../../../../../../UI/Forms/ImageInput/ImageInput'

const empProfileImage = ({ src, imageChanged }) => {
  return (
    <ImageInput
      src={src || null}
      changed={e => imageChanged('image_path', e)}
      variant={'circle'}
      imgAlt={'Employee Profile Image'}
      configs={{ style: { width: 150, height: 150 } }}
    />
  )
}
export default empProfileImage
